export class ChatUI {
    constructor(chatManager, settings) {
        this.chatManager = chatManager;
        this.settings = settings;
        this.messageInput = document.getElementById('messageInput');
        this.sendButton = document.getElementById('sendButton');
        this.newChatButton = document.getElementById('newChatButton');
        this.chatMessages = document.getElementById('chatMessages');
        this.isProcessing = false;
    }

    initialize() {
        this.setupEventListeners();
    }

    setupEventListeners() {
        this.sendButton.addEventListener('click', () => this.sendMessage());
        this.newChatButton.addEventListener('click', () => this.startNewChat());
        
        this.messageInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                this.sendMessage();
            }
        });
    }

    async sendMessage() {
        if (this.isProcessing || !this.messageInput.value.trim()) return;

        const message = this.messageInput.value.trim();
        
        // Disable input and button while processing
        this.isProcessing = true;
        this.messageInput.disabled = true;
        this.messageInput.value = '';
        this.messageInput.style.height = 'auto';
        this.sendButton.disabled = true;
        
        // Add user message to UI
        this.addMessageToUI('user', message);
        
        // Show typing indicator
        const typingIndicator = this.addTypingIndicator();
        
        try {
            // Get response from chat manager with retry logic
            const response = await this.chatManager.sendMessage(message);
            
            // Remove typing indicator and add response
            typingIndicator.remove();
            this.addMessageToUI('bot', response);
            
        } catch (error) {
            typingIndicator.remove();
            this.addErrorMessage(error.message);
        } finally {
            // Re-enable input and button
            this.isProcessing = false;
            this.messageInput.disabled = false;
            this.sendButton.disabled = false;
            this.chatMessages.scrollTop = this.chatMessages.scrollHeight;
            
            // Set focus back to input
            this.messageInput.focus();
        }
    }

    addMessageToUI(role, content) {
        const messageDiv = document.createElement('div');
        messageDiv.className = `message ${role}-message`;
        messageDiv.textContent = content;
        this.chatMessages.appendChild(messageDiv);
        this.chatMessages.scrollTop = this.chatMessages.scrollHeight;
    }

    addTypingIndicator() {
        const indicator = document.createElement('div');
        indicator.className = 'message bot-message typing-indicator';
        indicator.innerHTML = '<span></span><span></span><span></span>';
        this.chatMessages.appendChild(indicator);
        this.chatMessages.scrollTop = this.chatMessages.scrollHeight;
        return indicator;
    }

    addErrorMessage(error) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'message error-message';
        errorDiv.textContent = `Error: ${error}`;
        this.chatMessages.appendChild(errorDiv);
    }

    startNewChat() {
        this.chatMessages.innerHTML = '';
        this.chatManager.clearChat();
    }
}
